<template>
  <widget-container
      headlineclass
      cardclass=" ma-0 pa-1"
      :url="url"
      :bus="bus"
      :dark="false"
      :flat="false"
      color="transparent"
      :alwaysrender="true"
      @ready="setData"
  >
    <template slot="content">
      <div class>
        <v-row align="center">
          <v-col class="mb-3 text-right">
            <v-btn @click="copy" small depressed :disabled="this.table.items.length==0">
              <v-icon small>mdi-clipboard-outline</v-icon>
              Copier
            </v-btn>
          </v-col>
        </v-row>
        <div :style="'overflow-x: auto;margin:auto;' ">
          <div :style="'width:'+tableWidth+'px;border: 1px solid #e1e1e1;border-left:0;margin:auto;padding-top:-50px;'">
            <v-data-table
                v-model="table.items"

                :headers="table.headers"
                :items="table.items"
                :loading="table.loading"
                :items-per-page="1000"
                hide-default-footer
                no-data-text="Aucun message en attente"
                item-key="name"
                style="margin-top:-49px;"
                item-style="background-color:white">

              <template v-slot:header="{ props }">
                <th v-for="(header, i) in props.headers" :key="i" class="br-x" style="border-top:2px solid #e1e1e1;"
                    :class="[header.value === 'hotel' ? '': ' w-150' ]">
                  <div class="d-flex flex-column justify-space-between body-1 pa-2"
                       :class="header.value === 'total'? 'font-weight-medium':''">
                    {{ header.name }}
                    <div class="d-flex flex-row justify-space-around">
                       <span v-for="sub in header.subHeaders" :key="sub"
                             :class="header.value === 'total'? ' caption font-weight-medium':'caption'">
                         {{ sub }}
                       </span>
                    </div>
                  </div>
                </th>
              </template>


              <template v-for="(header,i) in table.headers"
                        v-slot:[`item.${header.value}`]="{ item }" class="">
                <div :key="header+'_'+i" :class="header.value === 'total'? 'font-weight-medium':''">
                  <div v-if="header.value === 'hotel'" style="cursor:pointer;" class="black--text">
                    {{ item.hotel }}
                  </div>
                  <div v-else style="cursor:pointer;" class="black--text d-flex justify-space-around">
                    <span>{{ getItemValue(item, header).value == 0 ? '' : getItemValue(item, header).value }}</span>
                    <span v-if="withLastYear">{{
                        getItemValue(item, header).previousValue == 0 ? '' : getItemValue(item, header).previousValue
                      }}</span>
                  </div>
                </div>
              </template>

              <template #foot>
                <tr class="font-weight-medium border-y" v-if="table.total != null">
                  <td class=" font-weight-medium body-1 pl-4 py-2"
                      :style="{width: '174px','border-left': '1px #e1e1e1 solid'}">{{
                      table.total.name
                    }}
                  </td>
                  <td v-for="(site,i) in table.total.sites" :key="'_'+i" class="body-1 px-4 font-weight-medium"
                      :style="{width:'154px','border-left': '1px #e1e1e1 solid'}">
                    <div style="cursor:pointer;" class="black--text d-flex justify-space-around ">
                      <span>{{ site.value }}</span>
                      <span v-if="withLastYear">{{ site.previousValue }}</span>
                    </div>
                  </td>
                  <td class="body-1 px-4 font-weight-medium black--text d-flex justify-space-around py-2"
                      style="border-left: 1px #e1e1e1 solid">
                    <span>{{ totalSum.value }}</span>
                    <span v-if="withLastYear">{{ totalSum.previousValue }}</span>
                  </td>

                </tr>
              </template>
            </v-data-table>

          </div>
        </div>
      </div>
    </template>
  </widget-container>
</template>

<script>
import WidgetContainer from "./WidgetContainer";
import clipboard from "../../../utils/clipboard";
import _ from "lodash";

export default {
  name: "WidgetNightsPerSite",
  components: {WidgetContainer},
  mixins: [],
  props: {
    bus: {
      type: Object,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    withLastYear: {
      type: Boolean,
      required: true,
    },
    sites: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      table: {
        loading: false,
        items: [],
        rowsPerPageItems: [{text: "Tous", value: -1}],
        headers: [],
      },
    };
  },
  created() {
    this.$nextTick(() => {
      this.bus.$on("search", (searchform) => {
        this.table.loading = true;
      });
    });
  },
  destroyed() {
    this.bus.$off("search");
  },
  watch: {},
  computed: {
    totalSum() {
      return {
        value: this.table.total.sites.map(site => site.value).reduce(this.sum, 0),
        previousValue: this.table.total.sites.map(site => site.previousValue).reduce(this.sum, 0)
      }
    },
    tableWidth() {
      if (this.table.headers.length > 0) {
        return this.table.headers
            .map((h) => (this.withLastYear ? h.fullSize : h.smallSize))
            .reduce((acc, curr) => acc + curr);
      } else return 0;
    },
  },
  methods: {
    sum(accumulator, a) {
      return accumulator + a;
    },
    setData(data) {
      const headers = [
        {name: "Hôtel", fullSize: 230, smallSize: 230, value: "hotel", subHeaders: [], sortable: false},
        ...data.headers.map((site) =>
            ({
              name: site.name,
              subHeaders: [],
              fullSize: 150,
              smallSize: 150,
              value: site.value,
              sortable: false,
              class: 'border-x blue'
            })),
        {name: "Total", fullSize: 150, smallSize: 150, value: "total", subHeaders: [], sortable: false},
      ];

      data.items = data.items.map(hotel => {
        hotel.sites.push(
            {
              siteId: 'total',
              hotelId: hotel.hotelId,
              hotel: 'total',
              nights: {
                name: "Total",
                value: hotel.sites.map(site => site.nights.value).reduce(this.sum, 0),
                previousValue: hotel.sites.map(site => site.nights.previousValue).reduce(this.sum, 0),
                diff: 0,
                percentageDiff: 0
              },
              year: 0,
              previous: false
            })
        return hotel
      })

      const usedYears = data.items.reduce((acc, curr) => {
        const addingValue = curr.sites.map(site => {
          let returnVal = []
          if (site.year == 0) return returnVal
          if (acc.some(ac => ac === site.year) && acc.some(ac => ac === site.year - 1)) {
            return acc;
          }
          if (site.nights.previousValue > 0 && !acc.some(ac => ac === site.year - 1)) {
            returnVal.push(site.year - 1)
          }

          if (!acc.some(ac => ac === site.year)) {
            returnVal.push(site.year)
          }
          return returnVal
        })

        acc.push(...addingValue)
        return acc
      }, []).flatMap(x => x)


      this.table = {
        loading: false,
        items: data.items.sort((a, b) => a.siteId - b.siteId),
        rowsPerPageItems: [{text: "Tous", value: -1}],
        headers: headers.map((h) =>
            (
                {
                  ...h,
                  subHeaders: h.value !== 'hotel' ?
                      usedYears.filter((item, index) => usedYears.indexOf(item) === index).sort((a, b) => b - a) : []
                })),
        total: {
          name: 'Total:',
          sites: data.total.map(item => item.nights),
        }
      }
    },
    getItemValue(item, header) {

      if (header.value === 'hotel') {
        return item.hotel
      } else if (header.value === 'total') {
        const row = item.sites.find(site => site.hotel === 'total')
        return row != null ? row.nights : ""
      } else {
        const row = item.sites.find(site => site.siteId === header.value)
        return row != null ? row.nights : ""
      }
    },

    copy() {
      const defaultSeparator = "\t";

      const buildCell = (item) => {
        if (this.withLastYear) {

          return `${
              item && item.nights && item.nights.value != null
                  ? item.nights.value
                  : 0
          }${defaultSeparator} ${
              item && item.nights && item.nights.previousValue != null
                  ? item.nights.previousValue
                  : 0
          }${defaultSeparator}`;
        } else {
          return `${
              item && item.nights
                  ? item.nights.value
                  : 0
          }${defaultSeparator}`;
        }
      };

      const headers = this.table.headers
          .map((h) => {
            return `${h.name}${defaultSeparator} ${
                !this.withLastYear ? "" : defaultSeparator
            }`;
          })
          .join(" ");

      const subHeaders = !this.withLastYear
          ? []
          : this.table.headers
              .map((h, idx) => {
                return h.subHeaders.sort((a, b) => a - b).join(defaultSeparator) + "\t"
              })
              .join(" ");

      const rows = this.table.items.map((i) => {
        const cell = i.sites.sort((a, b) => a.siteId - b.siteId)
            .map((m) => {
              return buildCell(m) ?? 0;
            })
            .join(" ");

        return `${i.hotel}${defaultSeparator}${cell}`;
      });
      const total = this.table.total.sites.sort((a, b) => a.siteId - b.siteId).map((i) => {
        if (this.withLastYear) {
          return `${i.value}${defaultSeparator}${i.previousValue}${defaultSeparator}`;
        } else {
          return `${i.value}${defaultSeparator}`;
        }
      }).join(" ");

      const globalTotal = ` ${this.totalSum.value}${defaultSeparator}${this.withLastYear ? this.totalSum.previousValue + defaultSeparator : ''}`;
      const allRows = [headers, subHeaders].concat(rows).concat(`Total: ${defaultSeparator}${total}${globalTotal}`);

      clipboard.copyTextToClipboard(allRows.join("\n"));
    },
  },
};
</script>

<style scoped>

>>> .text-start {
  border-left: 1px solid #d1d1d1;
}

>>> th {
  border-left: 1px solid #d1d1d1;
}

.border-x {

  border-right: 1px solid #e1e1e1;
}

.w-150 {
  width: 150px;
}
</style>
